export function isNodeList(el) {
  // Only NodeList has the "item()" function
  return typeof el.item !== "undefined"; 
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/tiny-slider/src/helpers/isNodeList.js
// module id = 42
// module chunks = 0